﻿import React from 'react';
import {Chip} from "@mui/material";
import {SearchFilterSearchChipMultiSelectRenderDiv} from "../styles";

interface SearchFilterSelectChipListProps {
  selected: Array<any>
}

const SearchFilterSelectChipList = ({selected = []}: SearchFilterSelectChipListProps) => {
  return selected.length > 0 && <SearchFilterSearchChipMultiSelectRenderDiv>
    {selected.map((value: string) => (
      <Chip size='small' key={value} label={value} />
    ))}
  </SearchFilterSearchChipMultiSelectRenderDiv>
}

export default SearchFilterSelectChipList;
